import { Basket } from '../types/basket.type';
import { UpdateBasketRequestDTO } from '../types/dtos/update-basket.dto';

export function buildBasketUpdatePayload(editedFields: Partial<Basket>): UpdateBasketRequestDTO {
  const payload: UpdateBasketRequestDTO = {};

  if (editedFields.name !== undefined) payload.name = editedFields.name;
  if (editedFields.reference !== undefined) payload.reference = editedFields.reference;
  if (editedFields.description !== undefined) payload.description = editedFields.description;
  if (editedFields.price !== undefined) payload.price = editedFields.price;
  if (editedFields.size !== undefined) payload.size = editedFields.size;
  if (editedFields.stock !== undefined) payload.stock = editedFields.stock;
  if (editedFields.isActive !== undefined) payload.isActive = editedFields.isActive;
  if (editedFields.isTop !== undefined) payload.isTop = editedFields.isTop;
  if (editedFields.isEco !== undefined) payload.isEco = editedFields.isEco;
  if (editedFields.labels !== undefined) payload.labels = editedFields.labels;
  if (editedFields.persons !== undefined) payload.persons = editedFields.persons;
  if (editedFields.availability !== undefined) payload.availability = editedFields.availability;

  if (editedFields.tax !== undefined) payload.taxId = editedFields.tax.id;
  if (editedFields.subCategory !== undefined) payload.subCategory = editedFields.subCategory.id;
  if (editedFields.tags !== undefined) payload.tags = editedFields.tags.map((tag) => tag.id);
  if (editedFields.weight !== undefined) {
    payload.weight = {
      from: editedFields.weight.from,
      to: editedFields.weight.to,
      unityId: editedFields.weight.unity.id,
    };
  }
  if (editedFields.products !== undefined) {
    payload.products = editedFields.products.map((basketProduct) => ({ productId: basketProduct.productId }));
  }

  return payload;
}
